import {
  TurboFetchRequestErrorEvent,
  TurboFrameMissingEvent,
} from "@hotwired/turbo";

export async function waitForTurboFrame(id: string) {
  return new Promise<void>((resolve) => {
    function handler(event: Event) {
      if (event.target instanceof Element && event.target.id !== id) return;
      document.documentElement.removeEventListener("turbo:frame-load", handler);
      return resolve();
    }
    document.documentElement.addEventListener("turbo:frame-load", handler);
  });
}
